import React from 'react'
import styled from '@emotion/styled'
import { ConfirmModal } from 'components/layout'
import { COLORS } from 'parameters/index'

interface CardProps {
	title: string
	onActionClick?: () => void
	actionButtonText?: string
	disableAction?: boolean
	children?: React.ReactNode
	withConfirm?: boolean
	style?: React.CSSProperties
}

const Card = ({
	title,
	onActionClick,
	actionButtonText = 'Edit',
	disableAction,
	children,
	withConfirm = false,
	style
}: CardProps): JSX.Element => (
	<CardWrapper style={style}>
		<CardTop>
			<CardTitle>{title}</CardTitle>
			{onActionClick && withConfirm && (
				<ConfirmModal
					trigger={<CardActionButton onClick={onActionClick}>{actionButtonText}</CardActionButton>}
					title="Are you sure you want to deactivate your account?"
					onConfirm={(): void => console.log('DELETE ACC')}
					confirmText="Yes, deactivate my account"
				/>
			)}
			{onActionClick && !withConfirm && !disableAction && (
				<CardActionButton onClick={onActionClick}>{actionButtonText}</CardActionButton>
			)}
		</CardTop>
		{children && <CardBody>{children}</CardBody>}
	</CardWrapper>
)

export default Card

const CardWrapper = styled.div`
	border-radius: 8px;
	box-shadow: 0 0 20px 0 rgba(69, 69, 69, 0.25);
	background-color: ${COLORS.WHITE};
	padding: 24px 16px;
	.submit {
		margin-top: 17px;
	}
`

const CardTop = styled.div`
	display: flex;
	justify-content: space-between;
`

const CardTitle = styled.h3``

const CardActionButton = styled.span`
	color: ${COLORS.MALACHITE_GREEN};
	text-decoration: underline;
	cursor: pointer;
`

const CardBody = styled.div`
	padding-top: 24px;
`
